import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist';
import account from './modules/account';
import adventures from './modules/adventures';
import applications from './modules/applications';
import backupCare from './modules/backupCare';
import interviewRequest from './modules/interviewRequest';
import job from './modules/job';
import messages from './modules/messages';
import navigation from './modules/navigation/index';
import sitterOnboarding from './modules/sitterOnboarding';
import { clearCache } from './cache';

Vue.use(Vuex);

clearCache();

const vuexSessionStorage = new VuexPersist({
  key: 'vuex', // display key in the browser session
  storage: window.sessionStorage,
  reducer: (state: any) => {
    // Persist UI data for fast reload, but reset connection state to force fresh reconnection
    const persistedChannelUrl = state.messages?.currentChannelUrl || null;
    return {
      ...state,
      messages: {
        // Persist all message UI data for instant display on reload
        currentChannelUrl: persistedChannelUrl,
        channels: state.messages?.channels || [],
        rawChannels: state.messages?.rawChannels || [],
        messages: state.messages?.messages || [],
        selectedOtherUser: state.messages?.selectedOtherUser || null,
        selectedChannelMembers: state.messages?.selectedChannelMembers || [],

        // Reset connection state to force fresh reconnection
        isConnected: false,
        isConnecting: false,
        lastReceivedMessageId: null,
        lastReceivedChannelUrl: null,
        connectionError: null,

        // Reset transient UI state (loading indicators, errors)
        // Set loadingMessages: true if we have a persisted channel to avoid empty state blink
        loadingChannels: false,
        channelListError: '',
        loadingMessages: !!persistedChannelUrl,
        messageLoadError: '',
        sendError: '',
        sending: false,
        queryParamChannelNotFound: false,
      },
      sitterOnboarding: state.sitterOnboarding,
    };
  },
});

const store = new Vuex.Store({
  plugins: [vuexSessionStorage.plugin],
  modules: {
    account,
    adventures,
    applications,
    backupCare,
    interviewRequest,
    job,
    messages,
    navigation,
    sitterOnboarding,
  },
});

export default store;
